import { HAZARD_MARKERS, IncidentSubType, Scheme, UiListTileLeadingColor } from '@/features/hazards';

type IncidentsToSchemeMap = Record<IncidentSubType, Scheme>;

export const incidentsToSchemeMap: IncidentsToSchemeMap = {
  // Bushfire
  [IncidentSubType.BushfireIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-bushfire'],
  },

  // Coastal Hazards
  [IncidentSubType.CoastalHazardIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-coastal-hazard'],
  },

  // Cyclone
  [IncidentSubType.CycloneIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-cyclone'],
  },

  // Damaging Winds
  [IncidentSubType.DamagingWindsIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-damaging-winds'],
  },

  // Earthquake
  [IncidentSubType.EarthquakeIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-earthquake'],
  },

  // Flood
  [IncidentSubType.FloodIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-flood'],
  },

  // Hazardous Materials
  [IncidentSubType.HazardousMaterialsIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-hazardous-materials'],
  },

  // Human Epidemic
  [IncidentSubType.HumanEpidemicIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-human-epidemic'],
  },

  // Human Pandemic
  [IncidentSubType.HumanPandemicIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-human-pandemic'],
  },

  // Other Incident
  [IncidentSubType.OtherIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-other-incident'],
  },

  // Rescue
  [IncidentSubType.RescueIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-rescue'],
  },

  // Storm
  [IncidentSubType.StormIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-storm'],
  },

  // Storm Surge
  [IncidentSubType.StormSurgeIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-storm-surge'],
  },

  // Storm Damage
  [IncidentSubType.StormDamageIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-storm-damage'],
  },

  // Structure Fire
  [IncidentSubType.StructureFireIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-structure-fire'],
  },

  // Tsunami
  [IncidentSubType.TsunamiIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-tsunami'],
  },

  // Road Incident
  [IncidentSubType.RoadIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-other-incident'],
  },

  // Road Work
  [IncidentSubType.RoadWorkEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-other-incident'],
  },

  // Blizzard
  [IncidentSubType.BlizzardIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-blizzard'],
  },

  // Tornado
  [IncidentSubType.TornadoIncidentEntity]: {
    leadingColor: UiListTileLeadingColor.Black,
    icon: HAZARD_MARKERS['ew-tornado'],
  },
};
